export default "__VITE_ASSET__eqlZ53D6__"